module.exports = __webpack_public_path__ + "static/media/01C.84690807.png";